<template>
  <!--内容-->
  <div class="bodybox cursorstyle">
    <p>专利提交申请</p>
    <div>
      <div style="display: flex;">
        <div class="title"><span style="color: red;">*</span>专利性质：</div>
        <div class="inputboxone" >
          {{this.nature_txt}}
        </div>

      </div>
    </div>
    <div class="">
      <div class="title"><span style="color: red;">*</span>专利类型：</div>
      <div style="display: flex;" class="bodybox_first">
        <el-checkbox-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="checkList"
                           @change="ele1btn">
          <el-checkbox label="1">发明专利</el-checkbox>
          <el-checkbox label="2">实用新型专利</el-checkbox>
          <el-checkbox label="3">外观设计专利</el-checkbox>
        </el-checkbox-group>
        <span style="line-height: 28px; color: red; margin-left: 5px;">(注：可多选)</span>
      </div>
    </div>
    <div id="">
      <div v-if="this.$route.query.create_type == 2">
        <!-- 录入Individual 个人 -->
        <IndividualEnter v-if="templateTpl == 'individual'" :templateTpl="this.ele1" @dataNature="dataNature"></IndividualEnter>
        <!-- 录入职务 -->
        <IndividualInventionEnterEnter v-if="templateTpl == 'Invention'" :templateTpl="this.ele1" @dataNature="dataNature"></IndividualInventionEnterEnter>
      </div>
      <div v-else>
        <!--  申请职务 -->
        <Invention v-if="templateTpl == 'Invention'" :templateTpl="this.ele1" @dataNature="dataNature"></Invention>
        <!--  申请Individual 个人 -->
        <IndividualInvention v-if="templateTpl == 'individual'" :templateTpl="this.ele1" @dataNature="dataNature">
        </IndividualInvention>
      </div>

    </div>

  </div>
</template>

<script>

// 职务
import Invention from './IndividualSubmission/Othertypes.vue'
// 个人
import IndividualInvention from './IndividualSubmission/invention.vue'

//录入
import IndividualEnter from './patent/IndividualSubmission/invention'
import IndividualInventionEnterEnter from './patent/IndividualSubmission/Othertypes'

export default {
  data() {
    return {
      nature_txt:'',
      ele1: '',
      // 1个人， 2其他组织
      nature: '',
      // 模版的切换
      templateTpl: '',
      checkList: ['1'],
    }
  },
  components: {
    Invention,
    IndividualInvention,
    IndividualEnter,
    IndividualInventionEnterEnter
  },
  created() {

  },
  mounted() {

    // 1个人， 2其他组织
    this.nature = this.userObj.info().nature
    this.nature_txt = this.userObj.info().nature_txt
    // this.nature = 2
    // 从缓存中获取
    if (this.nature == '1') {
      this.templateTpl = 'individual'
    } else {
      this.templateTpl = 'Invention'
    }
  },
  methods: {
    ele1btn(value) {
      this.ele1 = value
      // if (this.nature == '1') {
      // 	// let checkListjoin = value.join(',')
      // 	this.ele1 = value
      // } else{
      // 	this.ele1 = value
      // }
    },
    // 性质
    dataNature(value) {
      this.nature = value.nature
      this.checkList = value.checkList.split(',')
    },

  }
}
</script>

<style scoped="scoped">
.bodybox {
  width: 63vw;
  margin: 0 auto;
  /*border: 1px red solid;*/
  margin-top: 20px;
  /* border-left: 10px #fff solid; */
  color: #333333;
}

.bodybox > p {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  /* border: 1px red solid; */
  /*width: 8.4vw;*/
  /*text-align: right;*/
}

.bodybox > div {
  margin-top: 10px;
  display: flex;
  font-size: 14px;
}

.bodybox_first > div {
  margin-left: 20px;
}

.bodybox_first > div:first-child {
  margin-left: 10px;
  line-height: 28px;
}

.bodybox_first > div img {
  vertical-align: middle;
}

.bodybox > .PatentNature > div {
  line-height: 28px;
  margin-right: 20px;
}

.bodybox > .PatentNature > div > .inputbox {
  width: 164px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  line-height: 28px;
  padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;
}

.bodybox > .applicant {
  line-height: 28px;
}

.bodybox > .applicant > .inputbox {
  width: 1095px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;
}


.bodybox > .technology {
  line-height: 28px;
}

.bodybox > .technology > .inputbox {
  width: 164px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  line-height: 28px;
  padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;
}

.bodybox > .technology > .enclosure {
  color: #7CBDF8;
  line-height: 28px;
  padding-left: 6px;
}

.bodybox > .technology > .enclosure img {
  vertical-align: middle;
}

.bodybox > .explain > .inputbox {
  width: 329px;
  height: 192px;
  background: #D8D8D8;
  border-radius: 5px;
}

.bodybox > .explain > .explainbox {
  width: 740px;
  height: 180px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  margin-left: 10px;
  color: #E5E5E5;
  padding: 5px;
}

.bodybox > .tjbtn {
  width: 227px;
  height: 54px;
  background: #0D68BB;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 30px;
  color: #FFFFFF;
  font-size: 18px;
  line-height: 54px;
}

.bodybox > .tjbtn span {
  text-align: center;
  width: 227px;
}

.title {
  /*width: 9vw;*/
  /*text-align: right;*/

}

.inputboxone {
  width: 164px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #E5E5E5;
  line-height: 28px;
  padding-left: 4px;
  color: #A0A0A0;
  font-size: 14px;
  background: #E5E5E5;
}

.title {
  line-height: 28px;
}
</style>
